<template lang="pug">

	span.cartStatus.cursor-pointer(@click="toggleCart()" v-if="storeState.cartLoaded")
		| (
		transition(name="slide" mode="out-in")
			span(key="x") {{ cart_qty }}
		| )
				
</template>

<script>
import { store } from "./../shopify/store.js";

export default {
	name: 'CartStatus',
	data() {
		return {
			storeState: store.state
		}
	},
	computed: {
		cart_qty() {
			if (!this.storeState.cart?.lines?.edges) return 0;
			
			return this.storeState.cart.lines.edges.reduce((total, item) => {
				return total + (item.node?.quantity || 0);
			}, 0);
		}
	},
	methods: {
		toggleCart() {
			store.state.showCart = !store.state.showCart 
		}
	}
};
</script>
